import React from 'react';
import { Grid } from '@mui/material';

import { useFormState } from 'shared/hooks';
import useConsultData from 'features/consults/hooks/useConsultData';
import useConsultInitialFormState from 'features/consults/hooks/useConsultInitialFormState';
import { CONSULT_TABS } from 'features/consults/utils/constants';

import GridWrapper from 'shared/components/layout/GridWrapper/GridWrapper';
import QuestionsPanel from 'features/consults/components/tabFields/QuestionsPanel';

import schema from './validationSchema';
import { bloodPressureElements, rightElements } from './data';

const Plan = () => {
  const {
    control,
    register,
    getFieldError,
    getValues,
    setFormValues,
  } = useFormState(schema, { stateSlice: 'consults', showAsSnackbar: true });
  const { consult, consultTabData, isEditable, handleFieldChange } =
    useConsultData(CONSULT_TABS.PLAN, getValues);

  useConsultInitialFormState(consult.id, consultTabData, setFormValues);

  return (
    <GridWrapper>
      <Grid item sm={12} lg={6}>
        <QuestionsPanel
          control={control}
          register={register}
          onChange={handleFieldChange}
          getFieldError={getFieldError}
          disabled={!isEditable}
          elements={bloodPressureElements}
        />
      </Grid>
      <Grid item sm={12} lg={6}>
        <QuestionsPanel
          control={control}
          register={register}
          onChange={handleFieldChange}
          getFieldError={getFieldError}
          disabled={!isEditable}
          elements={rightElements}
        />
      </Grid>
    </GridWrapper>
  );
};

export default Plan;
